import { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from './hooks';
import {
  selectThemeMode,
  selectIsDarkMode,
  selectIsLightMode,
  selectThemeLoading,
  selectThemeError,
  setThemeMode,
  toggleTheme,
  setError,
  clearError,
} from '../slices/themeSlice';

export const useTheme = () => {
  const dispatch = useAppDispatch();
  
  // Selectors
  const themeMode = useAppSelector(selectThemeMode);
  const isDark = useAppSelector(selectIsDarkMode);
  const isLight = useAppSelector(selectIsLightMode);
  const loading = useAppSelector(selectThemeLoading);
  const error = useAppSelector(selectThemeError);

  // Actions
  const setTheme = useCallback((mode) => {
    if (mode === 'light' || mode === 'dark') {
      dispatch(setThemeMode(mode));
    }
  }, [dispatch]);

  const toggle = useCallback(() => {
    dispatch(toggleTheme());
  }, [dispatch]);

  const clearThemeError = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);

  // Initialize theme from system preference if not set
  useEffect(() => {
    if (!themeMode) {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      setTheme(prefersDark ? 'dark' : 'light');
    }
  }, [themeMode, setTheme]);

  // Listen for system theme changes
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const handleChange = (e) => {
      // Only auto-switch if user hasn't manually set a preference
      // This could be enhanced to track if user has manually set theme
      if (!localStorage.getItem('themeMode')) {
        setTheme(e.matches ? 'dark' : 'light');
      }
    };

    mediaQuery.addEventListener('change', handleChange);
    
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, [setTheme]);

  return {
    // State
    themeMode,
    isDark,
    isLight,
    loading,
    error,
    
    // Actions
    setTheme,
    toggleTheme: toggle,
    clearError: clearThemeError,
  };
};






















